<template>
  <v-dialog activator="parent" max-width="500">
    <template v-slot:default="{ isActive }">
      <v-card rounded="lg">
        <v-card-title class="d-flex justify-space-between align-center">
          <h2 v-if="!formSuccessMsg" class="form-title">
            {{ $t("QuotationModal.form.title") }}
          </h2>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="
              () => {
                isActive.value = false;
                closeModel();
              }
            "
          ></v-btn>
        </v-card-title>

        <!-- <v-divider class="mb-4"></v-divider> -->

        <div v-if="!formSuccessMsg" class="form-card">
          <v-form ref="form" v-model="form" @submit.prevent="submitForm">
            <!-- Name Field -->
            <v-text-field
              v-model="name"
              :label="$t('QuotationModal.form.name')"
              :placeholder="$t('QuotationModal.form.name')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule]"
              required
            ></v-text-field>

            <v-text-field
              v-model="companyName"
              :label="$t('QuotationModal.form.companyName')"
              :placeholder="$t('QuotationModal.form.companyName')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule]"
              required
            ></v-text-field>

            <!-- Phone Field -->
            <v-text-field
              v-model="phone"
              :label="$t('QuotationModal.form.phone')"
              :placeholder="$t('QuotationModal.form.phone')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule, phoneRule]"
              required
            ></v-text-field>

            <!-- Email Field -->
            <v-text-field
              v-model="email"
              :label="$t('QuotationModal.form.email')"
              :placeholder="$t('QuotationModal.form.email')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule, emailRule]"
              required
            ></v-text-field>

            <!-- Notes Field -->
            <v-textarea
              v-model="notes"
              :label="$t('QuotationModal.form.notes')"
              :placeholder="$t('QuotationModal.form.notesPlaceholder')"
              variant="outlined"
              outlined
              dense
              maxlength="100"
              rows="2"
              hide-details
              auto-grow
              required
            ></v-textarea>

            <div ref="turnstile" class="d-flex justify-center mt-4"></div>

            <!-- Submit Button -->

            <v-card-actions
              v-if="!formSuccessMsg"
              class="my-2 d-flex justify-end"
            >
              <v-btn
                class="text-none"
                variant="text"
                @click="
                  () => {
                    isActive.value = false;
                    closeModel();
                  }
                "
              >
                {{ $t("QuotationModal.form.cancelButton") }}
              </v-btn>

              <v-btn
                class="text-none"
                color="#bd9478"
                :loading="isLoading"
                type="submit"
                variant="flat"
              >
                {{ $t("QuotationModal.form.submitButton") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </div>

        <div
          v-else
          class="d-flex flex-column justify-center align-center form-success-msg"
        >
          <div class="success-icon">
            <svg
              class="w-12 h-12 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </div>
          <div class="content">
            <h2>
              {{
                this.formSuccessMsg?.trim()?.length === 0
                  ? "הטופס נשלח בהצלחה!"
                  : this.formSuccessMsg
              }}
            </h2>
            <p>{{ $t("QuotationModal.form.sentMessage") }}</p>
          </div>
        </div>

        <!-- <v-divider class="mt-2"></v-divider> -->
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getTurnstileToken } from "@/services/turnstile";
export default {
  name: "QuotationModal",
  components: {},
  emits: ["closeModel"],
  data() {
    return {
      form: false,
      isLoading: false,
      formSuccessMsg: "",
      notes: "",
      name: "",
      phone: "",
      email: "",
      companyName: "",
      // Validation rules
      requiredRule: (value) => !!value || "שדה זה חובה",
      emailRule: (value) =>
        /.+@.+\..+/.test(value) || 'יש להכניס כתובת דוא"ל תקינה',
      phoneRule: (value) =>
        /^[0-9]{10,15}$/.test(value) || "יש להכניס מספר טלפון תקין",
    };
  },
  methods: {
    closeModel() {
      this.$emit("closeModel");
    },
    async submitForm() {
      if (!this.form) return;
      try {
        this.isLoading = true;
        const token = await getTurnstileToken(
          "submit_form",
          this.$refs.turnstile
        );

        // Send form data to the server
        const response = await this.$store.dispatch(
          "Orders/submitQuotationForm",
          {
            name: this.name,
            phone: this.phone,
            email: this.email,
            notes: this.notes,
            companyName: this.companyName,
            token: token,
            guestCart: this.getCart,
          }
        );

        if (response.data.success) {
          // Clear form
          this.name = "";
          this.phone = "";
          this.email = "";
          this.notes = "";
          this.companyName = "";
          this.form = false;

          this.$store.dispatch("Orders/clearCart");

          // Show success message
          this.formSuccessMsg = response.data.message;
        }
      } catch (error) {
        console.error("Form submission error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    tofix(number, fix) {
      return Number(number)?.toFixed(fix);
    },
  },
  computed: {
    ...mapGetters({
      getCart: "Orders/getCart",
    }),
  },
};
</script>

<style lang="scss">
@media (max-width: 601px) {
  .quotation-modal {
    .gallery {
      .v-window.v-carousel {
        height: 330px !important;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .v-overlay__content:has(.quotation-modal) {
    max-width: calc(100% - 20px) !important;
  }
  .quotation-modal-content {
    margin-top: 60px !important;
    flex-direction: column !important;
  }
  .quotation-modal {
    height: unset !important;
    overflow-y: auto;
    width: 100%;
    padding: 10px !important;
    .close-icon {
      top: unset !important;
    }
  }

  .details {
    flex-basis: unset !important;
    width: 100% !important;
  }
}
</style>

<style scoped lang="scss">
.package-info {
  font-size: 14px;
  color: #afafaf;
}
.quantity-wrapper {
  max-width: 134px;
  display: flex;
  flex-direction: column;
}
.product-modal {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.product-modal-content {
  display: flex;
  margin-top: 100px;
  gap: 30px;
  flex-direction: row;
}

.image-container {
  flex-basis: 40%;
  width: 40%;
  position: relative;
}

.close-icon {
  z-index: 100;
  top: 20px;
  right: 20px;
  position: absolute;
}

.stock-label {
  display: inline-block;
  padding: 3px 20px 3px 10px;
  width: fit-content;
  background: #e6f6ef;
  color: #36b079;
  position: relative;
  margin-bottom: 20px;

  &::before {
    content: "";
    height: 6px;
    width: 6px;
    position: absolute;
    top: 50%;
    background-color: #36b079;
    right: 9px;
    transform: translateY(-50%);
    border-radius: 50%;
  }

  &.out-of-stock {
    color: #d13257;
    background: #f2e3e7;

    &::before {
      background-color: #d13257;
    }
  }
}

.product-image {
  width: 400px;
  height: 400px;
  object-fit: cover;
  border-radius: 10px;
}

.details {
  flex-basis: 65%;
  width: 300px;
}

.details-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.details-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.discount-percent {
  background: $primaryColor;
  color: white;
  padding: 5px 10px;
  height: fit-content;
}
.divider {
  width: 100%;
  border-top: 2px dashed rgba(212, 212, 212, 0.39);
}
h4 {
  font-size: 25px;
  font-weight: 500;
}

.description {
  line-height: 21px;
}

.isTablet,
.isMobile {
  .product-modal {
    flex-direction: column;
  }

  .image-container {
    width: 100%;
    flex-basis: auto;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .product-image {
    width: 220px;
    height: auto;
  }

  .details {
    flex-basis: auto;
    width: 100%;
  }

  .details-grid {
    grid-template-columns: 2fr 1fr;
  }

  .description,
  .prices {
    grid-column: 1 / -1;
  }
}
.form-card,
.form-title {
  padding: 25px;
}
.v-card-title {
  padding: unset !important;
}
.form-card {
  padding: 25px;
  padding-bottom: 0px;
}

@media (max-width: 601px) {
  .form-title {
    font-size: 20px !important;
  }
}
.form-success-msg {
  text-align: center;
  gap: 15px;
  padding: 45px;
}

.success-icon {
  background-color: #4caf50; /* Green background */
  border-radius: 50%; /* Rounded shape */
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon svg {
  stroke: white; /* Make the checkmark white */
  width: 60px;
  height: 60px;
}
</style>
